export default __webpack_public_path__ + "static/media/ForestGrassClassChange.3fa44cb5.png";